import {LooseGamePlay} from "../model/game-play";
import {PlayResult} from "../model/playResult";
import {Command} from "./Command";
import {GameInfo} from "../model/game";
import {ScoringPlay} from "../model/scoringPlay";
import {ODK} from "../model/odk";
import {PlayType} from "../model/playType";
import {environment} from "../../environment/environment";
import { HttpClient } from "@angular/common/http";
import {GameService} from "../services/game.service";

export class SetScoringPlayCommand implements Command {

  constructor(
    private gamePlay: LooseGamePlay,
    private gameInfo: GameInfo,
    private result: PlayResult,
    private http: HttpClient,
    private gameService: GameService
  ) { }

  execute() {
    console.log('COMMAND SetScoringPlayCommand', this.result)
    const {playType, result} = this.gamePlay

    this.gameInfo.homeScore = Number(this.gameInfo.homeScore) || 0;
    this.gameInfo.awayScore = Number(this.gameInfo.awayScore) || 0;

    if (this.gamePlay.odk === ODK.Offensive) {
        if (this.isPlayByDefenseOnField()) {
          this.gameInfo.awayScore += this.getScoringPts(this.result)
        } else {
          this.gameInfo.homeScore += this.getScoringPts(this.result)
        }
      }else if (this.gamePlay.odk === ODK.Defensive){
        if (this.isPlayByDefenseOnField()) {
          this.gameInfo.homeScore += this.getScoringPts(this.result)
        } else {
          this.gameInfo.awayScore += this.getScoringPts(this.result)
        }
      } else {
          if ([PlayType.FGBlock, PlayType.ExtraPtBlock, PlayType['2PtDefend'], PlayType.KO, PlayType.Punt].includes(this.gamePlay.playType!)) {
            if (
              (playType === PlayType.Punt && [PlayResult.Simple, PlayResult.SafetyReceivingTeam, PlayResult.FumbleDefTD].includes(result!)) ||
              (playType === PlayType.FGBlock && [PlayResult.NoGoodDefTD, PlayResult.BlockDefTD, PlayResult.TD].includes(result!)) ||
              (playType === PlayType.KO && [PlayResult.FumbleDefTD, PlayResult.Simple, PlayResult.Safety].includes(result!))
            ) {
              this.gameInfo.homeScore += this.getScoringPts(this.result);
            } else {
              this.gameInfo.awayScore += this.getScoringPts(this.result);
            }
          } else {
            if (
              (playType === PlayType.PuntRec && [PlayResult.Simple, PlayResult.SafetyReceivingTeam, PlayResult.FumbleDefTD].includes(result!)) ||
              (playType === PlayType.FG && [PlayResult.NoGoodDefTD, PlayResult.BlockDefTD, PlayResult.TD].includes(result!)) ||
              (playType === PlayType.KOREC && [PlayResult.FumbleDefTD, PlayResult.Simple, PlayResult.Safety].includes(result!)) ||
              (result === PlayResult.OnsideKickAwayTD)
            ) {
              this.gameInfo.awayScore += this.getScoringPts(this.result);
            } else {
              this.gameInfo.homeScore += this.getScoringPts(this.result);
            }
          }
      }

      if (this.gameInfo.id !== 'Démo') {
        this.postScoreToGame(this.gameInfo.id, this.gameInfo.homeScore, this.gameInfo.awayScore).subscribe()
        this.gameService.updateLocalScoreGameInfo(this.gameInfo.homeScore, this.gameInfo.awayScore)
      }
  }

  postScoreToGame(id: string, homeScore:number, awayScore:number)  {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return this.http.post<any>(`${environment.apiUrl}/game/update-score`, {id, homeScore, awayScore})
  }
  isPlayByDefenseOnField(){
    switch (this.gamePlay.result) {
      case PlayResult.InterceptionDefTD:
      case PlayResult.FumbleDefTD:
      case PlayResult.SackFumbleDefTD:
      case PlayResult.BlockDefTD:
      case PlayResult.NoGoodDefTD:
      case PlayResult.Safety:
      case PlayResult.SackSafety:
      case PlayResult.RushSafety:
        return true
      default:
        return false
    }
  }

  getScoringPts(result: PlayResult){
    switch(result){
        case PlayResult.CompleteTD:
        case PlayResult.RushTD:
        case PlayResult.TD:
        case PlayResult.BlockDefTD:
        case PlayResult.FumbleDefTD:
        case PlayResult.SackFumbleDefTD:
        case PlayResult.InterceptionDefTD:
        case PlayResult.NoGoodDefTD:
        case PlayResult.OnsideKickAwayTD:
        case PlayResult.OnsideKickHomeTD:
            return ScoringPlay.TD
        case PlayResult.Safety:
        case PlayResult.SackSafety:
        case PlayResult.RushSafety:
        case PlayResult.PenaltySafety:
        case PlayResult.SafetyReceivingTeam:
        case PlayResult.InterceptionSafety:
            return ScoringPlay.Safety
        case PlayResult.Good:
            if (this.gamePlay.playType === PlayType.FG || this.gamePlay.playType === PlayType.FGBlock) {
                return ScoringPlay.FG
            }else if (this.gamePlay.playType === PlayType.ExtraPt || this.gamePlay.playType === PlayType.ExtraPtBlock) {
                return ScoringPlay.ExtraPt
            } else if (this.gamePlay.playType === PlayType['2Pt'] || this.gamePlay.playType === PlayType['2PtDefend']) {
                return ScoringPlay.Conversion2Pt
            }else return 0
        case PlayResult.Simple:
            return ScoringPlay.Simple
        default:
            return 0
    }
  }

}
